import React, { useMemo, useState } from "react";
import { Activity, ActivityFeed } from "@ofqual/portal-activity-feed";
import {
  ActionType,
  ExpansionActivityFeedProps,
} from "./ExpansionActivityFeedTypes";
import { buildDefinitions } from "./buildDefinitions";
import { renderDialog } from "./renderDialog";
import { buildActions } from "./buildActions";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { UserRole } from "../../../domain/userRole";
import { UserType } from "../../../redux/types";
import { ActivityType } from "../../../domain/ActivityType";
import { authSelector } from "../../../redux/selectors";

export const ExpansionActivityFeed: React.FC<ExpansionActivityFeedProps> = ({
  application,
  evidenceRequests,
  isAdmin,
  disabled,
}) => {
  const [focussedEntity, setFocussedEntity] = useState<
    ActionType | Activity | null
  >(null);

  const { isInRole, userType } = useAuth(authSelector);
  const canSendMessage = isInRole(
    UserRole.AOAdmin,
    UserRole.AoResponsibleOfficer,
    UserRole.AORegulationTeam,
    UserRole.OfqualRecognitionExpansionAdmin,
    UserRole.ITAdmin
  );

  const canAddEvidence = isInRole(
    UserRole.AoResponsibleOfficer,
    UserRole.AORegulationTeam,
    UserRole.AOAdmin,
    UserRole.ITAdmin
  );

  const definitions = buildDefinitions(
    application,
    (activity) => setFocussedEntity(activity),
    canAddEvidence
  );

  const menuActions = buildActions(
    (entity) => setFocussedEntity(entity),
    disabled,
    isAdmin!,
    canSendMessage
  );

  const defaultExcludeActivityTypes = useMemo(
    () =>
      userType === UserType.AO
        ? {
            //TODO: double check this whitelist
            activityTypes: [
              ActivityType.ScopeMessageAo,
              ActivityType.ScopeMessageOfqual,
              ActivityType.ScopeAdditionalEvidenceRequest,
              ActivityType.ScopeClosed,
              ActivityType.ScopeChanged,
              ActivityType.ScopeAdditionalEvidenceSubmitted,
            ],
          }
        : {},
    [userType]
  );

  return (
    <>
      <ActivityFeed
        resourceId={application?.id}
        definitions={definitions}
        actions={menuActions}
        params={defaultExcludeActivityTypes}
      />
      {renderDialog(application, evidenceRequests, focussedEntity, () =>
        setFocussedEntity(null)
      )}
    </>
  );
};
